import { render, staticRenderFns } from "./editAuditoriumEdition.vue?vue&type=template&id=ad64638a"
import script from "./editAuditoriumEdition.vue?vue&type=script&lang=js"
export * from "./editAuditoriumEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports